import {
    type Ref,
    type ComputedRef,
    type WritableComputedRef,
    computed,
    ref,
} from 'vue'
import { useResizeObserver } from '@vueuse/core'

export function useInputRangeStyle(
    rangeClamped: ComputedRef<number>,
    rangeTotal: ComputedRef<number>,
    valueUi: WritableComputedRef<number>,
    minFinal: ComputedRef<number>,
    clampPercentLeft: ComputedRef<number>,
    clampPercentRight: ComputedRef<number>,
    props: {
        isPartOfTwoKnobbed: boolean
    }
): {
    thumbDiameterCss: string
    styleLabel: ComputedRef<string>
    classTwoKnobbed: ComputedRef<Record<string, boolean>>
    labelElement: Ref<HTMLLabelElement | null, HTMLLabelElement | null>
} {
    const thumbDiameter = 18
    const thumbDiameterCss = `${thumbDiameter}px`
    const labelElement: Ref<HTMLLabelElement | null> = ref(null)
    const clampedToTotal = computed(() => rangeClamped.value / rangeTotal.value)

    const labelWidth = ref(0)
    useResizeObserver(labelElement, (entries) => {
        labelWidth.value = entries[0]?.target.getBoundingClientRect().width || 0
    })

    const styleLabel = computed(() => {
        const progress =
            ((valueUi.value - minFinal.value) / rangeClamped.value) * 100

        return `left: clamp(
            -${clampPercentLeft.value / clampedToTotal.value}%,
            calc(${progress}% - ${labelWidth.value / 2}px - ${
                (thumbDiameter * (progress - 50)) / 100
            }px),
            calc(${
                100 + clampPercentRight.value / clampedToTotal.value
            }% - ${labelWidth.value}px)
        )`.trim()
    })

    const classTwoKnobbed = computed(() => ({
        'two-knobbed': props.isPartOfTwoKnobbed,
    }))

    return {
        thumbDiameterCss,
        styleLabel,
        classTwoKnobbed,
        labelElement,
    }
}
